<template>
  <div class="column is-full" v-if="visible">
    <div class="box">
      <div class="panel-header">
        <div class="panel-title">앱마켓</div>
        <div class="flex-align">
          <span class="unselect size-13 main" @click="clickOrderList">관리하기</span>
          <!--<i class="icon-close material-icons unselect" @click="clickClose">close</i>-->
        </div>
      </div>

      <div class="panel-content">
        <!-- 플랫폼 팩 -->
        <div class="flex-between">
          <div class="flex-align unselect" @click="packages.visible = !packages.visible">
            <i class="material-icons">keyboard_arrow_{{ packages.visible ? 'up' : 'down' }}</i>
            <div class="size-15 weight-500">테마/플랫폼 팩(서비스 주문방식) <span class="primary" style="margin-left:4px">{{ packages.packages.length }}</span>
            </div>
          </div>
          <div class="unselect flex-align primary size-13 weight-500" @click="clickAddPack">
            <i class="material-icons ic-add">add</i>추가</div>
        </div>
        <!-- 팩 카드 -->
        <div v-if="packages.visible" class="horizontal-wrapper">
          <scroll-table-wrapper :enableDragScroll="true">
            <div class="flex-align">
              <div class="card-pack" v-for="(item,idx) in packages.list" :key="'card-pack-'+idx">
                <div class="img-wrapper">
                  <img :src="item.img">
                  <div class="dim" v-if="packages.packages.indexOf(item.key)===-1" @click="clickPackItem(item)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L12 22" stroke="white" stroke-width="3" stroke-linecap="round"/>
                      <path d="M2 12L22 12" stroke="white" stroke-width="3" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <div v-if="item.tag" :class="`pack-tag${item.tag === '기본제공' ? '-basic' : ''}`">{{ item.tag }}</div>
                </div>
                <div class="size-12 main" style="margin:8px 0 4px 0">{{ item.title }}</div>
                <div class="size-12 sub3 ellipsis">{{ item.desc }}</div>
              </div>
            </div>
          </scroll-table-wrapper>
        </div>
        <div class="divider"></div>

        <!-- 플러그인 -->
        <div class="flex-between">
          <div class="flex-align unselect" @click="plugins.visible = !plugins.visible">
            <i class="material-icons">keyboard_arrow_{{ plugins.visible ? 'up' : 'down' }}</i>
            <div class="size-15 weight-500">플러그인<span class="primary" style="margin-left:4px">{{ plugins.plugins.length }}</span>
            </div>
          </div>
          <div class="unselect flex-align primary size-13 weight-500" @click="clickAddPlugin">
            <i class="material-icons ic-add">add</i>추가</div>
        </div>

        <div v-if="plugins.visible" style="margin-top:20px">
          <div v-if="plugins.plugins.length===0" class="size-12" style="color:#a49d9d">추가한 플러그인이 없습니다</div>
          <div class="grid-plugin" v-else>
            <div v-for="(item,idx) in plugins.plugins" :key="'card-plugin-'+idx" class="card-plugin">
              <div class="img-wrapper">
                <img :src="item.icon">
              </div>
              <div>
                <div class="flex-align" style="gap:0 4px">
                  <div class="size-12 main flex-1">{{ item.name }}</div>
                  <div class="plugin-tag" v-if="item.admin">관리자</div>
                </div>
                <div v-if="item.status === 6" class="status-6">설치중...</div>
                <div v-if="item.status === 2 && item.key && item.key !== ''"
                     class="status-2 unselect" @click="clickFeature(item)">기능설정</div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>

        <!-- 추가서비스 -->
        <div class="flex-between">
          <div class="flex-align unselect" @click="services.visible = !services.visible">
            <i class="material-icons">keyboard_arrow_{{ services.visible ? 'up' : 'down' }}</i>
            <div class="size-15 weight-500">추가서비스<span class="primary" style="margin-left:4px">{{ services.services.length }}</span>
            </div>
          </div>
          <div class="unselect flex-align primary size-13 weight-500" @click="clickAddPlugin">
            <i class="material-icons ic-add">add</i>추가</div>
          </div>

        <div v-if="services.visible" style="margin-top:20px">
          <div v-if="services.services.length===0" class="size-12" style="color:#a49d9d">추가한 추가서비스가 없습니다</div>
          <div class="grid-plugin" v-else>
            <div v-for="(item,idx) in services.services" :key="'card-plugin-'+idx" class="card-plugin">
              <img class="img-wrapper" :src="item.img">
              <div>
                <div class="size-12 main">{{ item.name }}</div>
                <div class="flex-align"style="gap:4px">
                  <div class="status-6" v-if="item.status === 6" >기능 추가 중</div>
                  <div class="status-2 unselect"
                       v-if="(item.status === 2 && item.key === '') || [1,4,5,6].indexOf(item.status)>-1"
                       @click="clickInquiry(item)">1:1문의</div>
                </div>
                <div v-if="item.status === 2 && item.key && item.key !== ''"
                     class="status-2 unselect" @click="clickFeature(item)">기능설정</div>
              </div>
            </div>
          </div>
        </div>

        <div class="unselect box-app-market" @click="$root.$emit('appMarket')">
          <div>플랫폼을 한 단계 더 업그레이드! <b>다양한 기능을 추가할 수 있는 앱마켓</b></div>
          <i class="material-icons" style="font-size:18px">arrow_forward</i>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import ScrollTableWrapper from "../../module/common/ScrollTableWrapper";

  export default {
    name: "ServicePackagePanel",
    components: {ScrollTableWrapper},
    created() {
      if(this.$route.query.plugin_key) {
       this.clickFeature({
         key: this.$route.query.plugin_key
       })
      }
      this.init();
    },
    computed: {
      visible() {
        return this.$store.getters.dashboardPanel.visible.packages && this.serviceInfo && this.serviceInfo.service_type === 4;
      }
    },
    data() {
      return {
        packages: {
          visible: true,
          packages: [],
          list: [
            {
              key: 'call',
              title: '전화주문',
              desc: '전화로 상품을 주문하는 팩',
              img: 'https://launchpack-storage.s3.ap-northeast-2.amazonaws.com/media/img/product/22448917.png'
            },
            {
              key: 'delivery',
              title: '상품 택배 배송',
              desc: '상품 결제/ 택배배송 시스템 제공',
              tag: '결제기능제공',
              img: 'https://launchpack-storage.s3.ap-northeast-2.amazonaws.com/media/img/product/18850328.png'
            },
            {
              key: 'reservation',
              title: '서비스예약(시간)',
              desc: '시/분 단위 서비스 예약/결제 제공',
              tag: '결제기능제공',
              img: 'https://launchpack-storage.s3.ap-northeast-2.amazonaws.com/media/img/product/40628112.png'
            },
            {
              key: 'booking',
              title: '서비스예약(기간)',
              desc: '기간(일) 단위 서비스 예약/결제 제공',
              tag: '결제기능제공',
              img: 'https://launchpack-storage.s3.ap-northeast-2.amazonaws.com/media/img/product/12686216.png'
            },
            {
              key: 'board',
              title: '커뮤니티',
              desc: '게시판/댓글 기능 제공',
              img: 'https://launchpack-storage.s3.ap-northeast-2.amazonaws.com/media/img/non-path/49826802.png'
            },
          ]
        },
        plugins: {
          visible: true,
          plugins: []
        },
        services: {
          visible: true,
          services: []
        }
      }
    },
    watch: {
      '$store.getters.getPackages'() {
        this.init();
      },
      '$store.getters.getInternalPlugin'() {
        this.init();
      }
    },
    methods: {
      clickInquiry(item) {
        this.routerPush(`/office/admin/launchpack/inquiry/customer/create?id=${item.customer_inquiry}`);
      },
      async clickFeature(item) {
        const featureLink = [
          {
            path: 'service/setting',
            keys: ['virtual_account', 'naverpay', 'kakaopay', 'mobile_payment', 'account_transfer', 'pg_card',]
          },
          {
            path: 'service/account',
            keys: ['sns_signin']
          },
          {
            path: 'partner',
            keys: ['partner_video']
          },
          {
            path: 'product',
            keys: ['recent_product', 'product_image_upload', 'product_video', 'product_priority', 'sns_inquiry',
              'product_file_upload', 'time_sale']
          },
          {
            path: 'exhibition_partner_product',
            keys: ['partner_product_exhibition']
          },
          {
            path: 'exhibition_partner',
            keys: ['partner_exhibition']
          },
          {
            path: 'order',
            keys: ['order_detail_print']
          },
          {
            path: 'service/account?menu=verify',
            keys: ['nice_identity_verify', 'identity_verify', 'age_verify']
          },
          {
            path: 'filter',
            keys: ['category_filterset']
          },
          {
            path: 'partner/approval/all',
            keys: ['partner_approval']
          },
          {
            path: 'supervisor',
            keys: ['supervisor']
          },
          {
            path: 'service/account?menu=channel_io',
            keys: ['channel']
          },
          {
            path: 'point/setting',
            keys: ['point_coupon']
          },
          {
            path: 'push',
            keys: ['app_notification']
          },
          {
            path: 'product/evaluation',
            keys: ['product_review_rate']
          },
          {
            path: 'user/param/create',
            keys: ['user_param']
          },
          {
            path: 'partner/param/create',
            keys: ['partner_param']
          },
          {
            path: 'product/param/create',
            keys: ['product_param']
          },
          {
            path: 'product/grade',
            keys: ['partner_grade']
          },
          {
            path: 'guide',
            keys: ['guide']
          },
          {
            path: 'partner/inquiry/new',
            keys: ['partner_inquiry']
          },
          {
            path: 'popup',
            keys: ['popup']
          },
          {
            path: 'product/approval/new',
            keys: ['product_approval']
          },
          {
            path: 'board',
            keys: ['board']
          },
          {
            path: 'user/grade',
            keys: ['user_grade']
          },
          {
            path: 'service/info',
            keys: ['domain']
          }
        ];
        let feature = featureLink.find(i => i.keys.indexOf(item.key) > -1);
        if(feature) {
          let path = feature.path;
          if(feature.path === 'order') {
            let pack = this.serviceInfo.package;
            let res = await this.$axios.get(this.getUrl(`${pack}/order?cur_page=1&page_length=1`));
            if(res.data.data.length>0) {
              if(pack === 'delivery') {
                path = `delivery/order/detail?id=${res.data.data[0].id}`;
              } else {
                path = `${pack}/order_detail?id=${res.data.data[0].id}`;
              }
            } else {
              if(pack === 'delivery') {
                path = 'delivery/order_list_pay_all';
              } else {
                path = `${pack}/order_list_all`;
              }
            }
          }
          this.routerPush(`/office/admin/${path}`);
        }
      },
      getPath(cat) {
        return `https://master-dev.launchpack.co.kr:1111/user/0/mapping/product?&category=${cat}&fields=id,name,img,params&page_num=1&page_length=100`
      },
      clickClose() {
        let panel = this.$store.getters.dashboardPanel;
        panel.visible.packages = false;
        this.$store.commit('setDashboardPanel', panel);
      },
      init() {
        this.$axios.get(this.getPath(47)).then(res => {
          res.data.data.forEach(i => {
            let key = i.params.filter(p => p.name === 'key')[0].value;
            let item = this.packages.list.filter(p => p.key === key)[0];
            item.id = i.id;
            item.img = i.img;
          });
          this.packages.packages = this.$store.getters.getPackages.map(i => i.name);
        });

        this.$axios.get(`${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/v1/service/${this.$store.getters.masterService.service_id}/app_order`).then(res => {
          /*
          1: 신청
          2: 이용중
          3: 이용중단
          4: 안내완료
          5: 결제완료
          6: 작업중
           */
          res.data = res.data.filter(i => i.status !== 3);
          this.plugins.plugins = res.data.filter(i => i.app_type === 'plugin').map(i => {
            let product = i.products[0];

            return {
              key: product.key,
              name: product.name,
              icon: product.icon,
              admin: product.plugin_range.indexOf('관리자')>-1,
              status: i.status
            }
          });

          this.services.services = res.data.filter(i => i.app_type === 'service').map(i => {
            let product = i.products[0];
            return {
              customer_inquiry: i.customer_inquiry,
              name: product.name,
              img: product.imgs[0],
              icon: product.icon,
              status: i.status
            }
          });
        });
      },
      clickOrderList() {
        this.$root.$emit('appMarket', {order_list: true});
      },
      clickAddPack() {
        this.$root.$emit('appMarket', {category: 47});
      },
      clickPackItem(item) {
        this.$root.$emit('appMarket', {detail: item.id});
      },
      clickAddPlugin() {
        this.$root.$emit('appMarket', {category: 48});
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .panel-title
    color $main
    font-size 21px
    font-weight 300

  .icon-close
    color rgba(0, 0, 0, 0.54)
    margin-left 16px

  .panel-content
    padding 20px

  .horizontal-wrapper
    margin-top 20px
    height 148px
    overflow hidden

  .card-pack
    margin-right 38px

    .img-wrapper
      width 140px
      height 100px
      border-radius 4px
      overflow hidden
      border 1px solid #eeeeee
      position relative

      img
        width 100%
        height 100%
        object-fit cover
        object-position top

      .dim
        background-color rgba(0, 0, 0, 0.5)
        width 100%
        height 100%
        position absolute
        cursor pointer !important
        top 0
        left 0
        display flex
        align-items center
        justify-content center

      .pack-tag
      .pack-tag-basic
        position absolute
        top 0
        right 0
        border-bottom-left-radius 4px
        font-size 11px
        padding 4px 6px

      .pack-tag
        color #00944D
        background #C6FFD9

      .pack-tag-basic
        color $primary
        background-color $primary-light2

    .ellipsis
      width 140px
      text-overflow ellipsis
      overflow hidden
      white-space nowrap
      word-wrap normal


  .divider
    margin 24px 0
    width 100%
    height 1px
    background-color #eeeeee

  .flex-1
    flex 1

  .grid-plugin
    display grid
    grid-template-columns repeat(3, 1fr)
    grid-column-gap 20px
    grid-row-gap 20px

  .card-plugin
    display flex
    align-items center
    .img-wrapper
      width 56px
      height 56px
      border-radius 8px
      background-color $gray3
      display flex
      align-items center
      justify-content center
      margin-right 6px

      img
        width 20px
        height 20px

    .plugin-tag
      color $primary
      background-color $primary-light2
      font-size 11px
      border-radius 4px
      padding 2px 4px
      width 40px
      margin-bottom 2px


  .box-app-market
    color #7B61FF
    background-color #EFECFF
    border-radius 4px
    padding 8px 12px
    display flex
    justify-content space-between
    align-items center
    margin-top 24px

  .ic-add
    font-size 17px
    margin-right 4px

  .status-2
  .status-6
    font-size 12px
    margin-top 4px

  .status-2
    text-decoration underline
    color #FF5722
  .status-6
    color #787878
</style>
